import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Modal,
  Button,
  Row,
  Col,
  Checkbox,
  Select as AntdSelect,
  Form as AntdForm,
} from "antd";
import {
  getRequest,
  getRequestFormFields,
  getRequestUserPositions,
  emptyRequestWrits,
  emptyRequest,
  emptyRequestFormField,
  emptyRequestUserPositions,
  getMissionRequests,
  getWritRequests,
} from "../../../../routes/Home/Requests/Box/Outbox/Module";
import PositionsList from "routes/Home/Requests/Procedure/Definition/Form/Applicants";
import {
  getUserRequestTypes,
  getPositionRequestTypes,
  emptyUserRequestType,
  emptyPositionRequestType,
} from "../../../../routes/Home/Requests/Dashboard/Module";
import { getUserInfo } from "routes/Home/Basic/Personnel/Module";
import { Field, reduxForm, getFormValues, isPristine } from "redux-form";
import {
  Text,
  TextArea,
  Date,
  Time,
  Cascader,
  Select,
  Number,
  File,
} from "components/redux-form";
import Spin from "components/common/Spin";
// import validate from "./validate";
import MaterialIcon from "components/common/MaterialIcon";
import TimePicker from "components/common/TimePicker";
import jMoment from "components/classes/Jmomen";
import uuidv1 from "uuid/v1";
import { FormBuilder } from "components/FormBuilder";
import Types from "routes/General/Types";
import moment from "moment-jalaali";

@reduxForm({
  form: "FormBuilder",
  onSubmit: (values, dispatch, props) => {
    const _values = values.$clone();

    let field = ["positionId", "values", "description", "sender", "valueType"];

    // _values.requestTypeId = _values.typeId;
    _values.sender.positionId = parseInt(_values.sender.positionId);

    for (let _value in _values) {
      if (!field.includes(_value)) {
        delete _values[_value];
      }
    }
    if (_values.values && Object.keys(_values.values).length > 0) {
      for (let _value in _values.values) {
        if (!_values.values[_value]) {
          delete _values.values[_value];
        }
      }
    }
    // if (_values?.typeId?.length !== 0 || _values) {
    //   props.onSubmitTouch(_values, "");
    // }
  },
})
@connect(
  (state) => ({
    currentUser: state.Auth.currentUser,
    request: state.Requests.Box.Outbox.request,
  }),
  {
    getPositionRequestTypes,
  }
)
@autobind
/**
 *
 */
export default class Form extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string,
    active: PropTypes.arrayOf(PropTypes.object),
    onSubmitTouch: PropTypes.func,
    onCancelTouch: PropTypes.func,
    getRequest: PropTypes.func,
    getRequestFormFields: PropTypes.func,
    getRequestUserPositions: PropTypes.func,
    getUserRequestTypes: PropTypes.func,
    getPositionRequestTypes: PropTypes.func,
    getMissionRequests: PropTypes.func,
    getWritRequests: PropTypes.func,
    emptyRequestWrits: PropTypes.func,
    emptyUserRequestType: PropTypes.func,
    emptyPositionRequestType: PropTypes.func,
    emptyRequest: PropTypes.func,
    emptyRequestFormField: PropTypes.func,
    emptyRequestUserPositions: PropTypes.func,
    getUserInfo: PropTypes.func,
    onChangeTypeSubmit: PropTypes.func,
    visibility: PropTypes.bool,
    request: PropTypes.object,
    currentUser: PropTypes.object,
    requestFormFields: PropTypes.arrayOf(PropTypes.object),
    requestUserPositions: PropTypes.array,
    userOrPositionRequestTypes: PropTypes.array,
    formTitle: PropTypes.string,
    // requestUserPositions: PropTypes.arrayOf(
    //   PropTypes.object,
    // ),
    values: PropTypes.object,
    submit: PropTypes.func,
    type: PropTypes.string,
    visible: PropTypes.bool,
    rowClick: PropTypes.object,
    paragraph: PropTypes.object,
    fromTime: PropTypes.string,
    valueType: PropTypes.string,
  };

  static defaultProps = {};

  /**
   *
   * @param {object} props
   */
  constructor(props) {
    super(props);
    this.state = {
      requestTypes: [],
      onClickRowsRequests: this.props.onClickRows.requests,
      onClickRows: this.props.onClickRows,
      reasons: [],
    };
  }

  /**
   *
   */
  componentDidMount() {
    this.setState({ reasons: Types.items("Request") });
  }
  /**
   *
   * @param {Object} items
   * @param {Object} key
   * @return {Object|undefined}
   */
  findObject(items, key) {
    let result = app._.find(items, key);
    let x;
    if (result === undefined) {
      for (x in items) {
        if (!app._.isEmpty(items[x].children)) {
          let result = this.findObject(items[x].children, key);
          if (result !== undefined) {
            return result;
          }
        }
      }
      return undefined;
    } else {
      if (result?.fullLabel) {
        return result.fullLabel;
      } else {
        return result.label;
      }
    }
  }

  _typeId(typeId) {
    let _reason;
    _reason = this.findObject(this.state.reasons, { id: typeId });
    typeId = _reason !== undefined ? _reason : "undefined";
    return _reason;
  }
  /**
   *
   */
  componentWillUnmount() {
    super.componentWillUnmount();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!app._.isEqual(this.props.values, nextProps.values)) {
      // console.log('props', this.props.values, nextProps.values);
      return true;
    }
    if (!app._.isEqual(this.state, nextState)) {
      // console.log('state', this.state, nextState);
      return true;
    }
    return false;
  }

  /**
   *
   * @param {Object[]} groups
   * @param {Number} group
   * @return {String[]}
   * @private
   */
  _getGroupIds(groups, group) {
    let _ids = [];

    groups.map((_group) => {
      if (_group.id === group) {
        _ids.push(_group.id);
      } else if (!app._.isEmpty(_group.children)) {
        let _id = this._getGroupIds(_group.children, group);
        if (_id.length > 0) {
          _ids.push(_group.id, ..._id);
        }
      }
    });

    return _ids;
  }

  _renderSenderPosition() {
    let select = [];
    let { currentUser, type } = this.props;
    let positionId =
      currentUser && currentUser.positions
        ? currentUser.positions.pluck("id")
        : [];
    let i = 0;
    if (currentUser && currentUser.positions && currentUser.profile) {
      app._.map(currentUser.positions, (position) => {
        i++;
        select.push(
          <AntdSelect.Option
            key={`sender_${position.id}`}
            value={`${position.id}`}
            style={{
              borderBottom: `1px solid #${
                positionId.length === i ? "ccc" : "f6f6f6"
              }`,
            }}
          >
            {position.name}
            <span className="select-span">
              {currentUser.profile.firstName} {currentUser.profile.lastName}
            </span>
          </AntdSelect.Option>
        );
      });
    }
    return (
      <Field
        name={`sender['positionId']`}
        label={app.translate("routes.home.requests.Sender", "Sender")}
        component={Select}
        disabled={type === "edit"}
      >
        <AntdSelect.Option
          style={{
            borderBottom: "1px solid #ccc",
          }}
          value="0"
        >
          {app.translate("routes.home.requests.Select Position")}
        </AntdSelect.Option>
        {select}
      </Field>
    );
  }

  /**
   *
   * @param {Object[]} groups
   * @return {Object[]}
   * @private
   */
  _renderGroups(groups) {
    let _groups = [];
    groups.map((group) => {
      if (this._findRequestTypeAccess(group.id) || !group.rule) {
        let _group = {
          value: group.id,
          label: group.label,
          form: group.form,
        };

        if (!app._.isEmpty(group.children)) {
          _group.children = this._renderGroups(group.children);
        }
        _groups.push(_group);
      }
    });
    return _groups;
  }

  render() {
    const {
      currentUser,
      onChangeTypeSubmit,
      onCancelTouch,
      visible,
      title,
      submit,
      isPristine,
      type,
      rowClick,
      formTitle,
      paragraph,
      fromTime,
      toTime,
      valueType,
      typeSubmit,
      columnTitle,
    } = this.props;
    const { disable, spinning } = this.state;
    const { validateStatus, help, onClickRowsRequests, onClickRows } =
      this.state;

    let requestTypes = [];
    if (
      !app._.isEmpty(this.props.userOrPositionRequestTypes) &&
      !app._.isEmpty(this.state.requestTypes)
    ) {
      requestTypes = this._renderGroups(this.state.requestTypes);
    }
    const itemsOfTable = [requestTypes[0]];

    return (
      <Modal
        title={"وضعیت درخواست ها"}
        visible={visible}
        maskClosable={isPristine}
        wrapClassName="vertical-center-modal"
        style={{ height: "45%" }}
        width={!paragraph ? "60%" : "20%"}
        onCancel={onCancelTouch}
        footer={[
          <Button key="back" size="large" onClick={onCancelTouch}>
            {app.translate("main.Cancel")}
          </Button>,
        ]}
      >
        <Row
          className="request-info"
          style={{ maxHeight: "400px", height: "30px" }}
        >
          {onClickRowsRequests.map((item, index) => (
            <Col sm={24} md={24}>
              <Row>
                <Col sm={4} className="request-info-title">
                  <MaterialIcon name="note-outline" size="tiny" />{" "}
                  {app.translate("routes.home.requests.Type")}:
                </Col>
                <Col sm={8}>{this._typeId(item.typeId)}</Col>
                <Col sm={4} className="request-info-title">
                  <MaterialIcon name="account" size="tiny" />{" "}
                  {app.translate("routes.home.requests.Owner")}:
                </Col>
                <Col sm={8}>{onClickRows.person}</Col>

                {/* <Col sm={8} className="request-info-title">
        <MaterialIcon name="account-card-details" size="tiny" /> {app.translate('routes.home.requests.Position')}
      </Col>
      <Col sm={16}>
        ۴۴۰
      </Col>
      <Col sm={8} className="request-info-title">
        <MaterialIcon size="tiny" name="calendar" /> {app.translate('routes.home.requests.UpdatedAt')}
      </Col>
      <Col sm={16}>
        <span dir="ltr">{
          // jMoment(request.updatedAt, 'YYYY-M-D HH:mm:ss').format('jYYYY/jMM/jDD HH:mm:ss')
        } 2022/12/12</span>
      </Col> */}

                {item.values.date || item.values.clockingType ? (
                  <Row>
                    <Col sm={4} className="request-info-title">
                      <MaterialIcon name="note-outline" size="tiny" />{" "}
                      {app.translate("routes.home.requests.clockingType")}:
                    </Col>
                    <Col sm={8}>
                      {item.values.clockingType === "in"
                        ? "ورود"
                        : item.values.clockingType === "out"
                        ? "خروج"
                        : "درانتظار"}
                    </Col>
                    <Col sm={4} className="request-info-title">
                      <span className="request-info-title">
                        <MaterialIcon size="tiny" name="clock" />{" "}
                        {app.translate("routes.home.attendance.clocking.Date")}:
                      </span>
                    </Col>
                    <Col md={8}>
                      {jMoment(item.values.date, "YYYY-M-D ").format(
                        "jYYYY/jMM/jDD "
                      )}
                    </Col>
                    <Col sm={4} className="request-info-title">
                      <span>
                        <MaterialIcon size="tiny" name="clock" />{" "}
                        {app.translate("routes.home.attendance.clocking.Time")}:
                      </span>
                    </Col>
                    <Col md={8}>
                      {jMoment(item.values.time, "HH:mm:ss").format(
                        " HH:mm:ss"
                      )}
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    {item.values.dateFrom && (
                      <Row sm={12} s>
                        <Col sm={4} className="request-info-title">
                          <span className="request-info-title">
                            <MaterialIcon size="tiny" name="clock" />{" "}
                            {app.translate(
                              "routes.home.attendance.clocking.FromDate"
                            )}
                            :
                          </span>
                        </Col>
                        <Col md={8}>
                          {jMoment(item.values.dateFrom, "YYYY-M-D ").format(
                            "jYYYY/jMM/jDD"
                          )}
                        </Col>
                        <Col sm={4} className="request-info-title">
                          <span className="request-info-title">
                            <MaterialIcon size="tiny" name="clock" />{" "}
                            {app.translate(
                              "routes.home.attendance.clocking.ToDate"
                            )}
                            :
                          </span>
                        </Col>
                        <Col md={8}>
                          {jMoment(item.values.dateTo, "YYYY-M-D ").format(
                            "jYYYY/jMM/jDD "
                          )}
                        </Col>
                      </Row>
                    )}
                    {item.values.timeFrom && (
                      <Row sm={12}>
                        <Col sm={4} className="request-info-title">
                          <span>
                            <MaterialIcon size="tiny" name="clock" />{" "}
                            {app.translate(
                              "routes.home.attendance.clocking.FromTime"
                            )}
                            :
                          </span>
                        </Col>
                        <Col md={8}>
                          {jMoment(item.values.timeFrom, "HH:mm:ss").format(
                            " HH:mm:ss"
                          )}
                        </Col>
                        <Col sm={4} className="request-info-title">
                          <span className="request-info-title">
                            <MaterialIcon size="tiny" name="clock" />{" "}
                            {app.translate(
                              "routes.home.attendance.clocking.ToTime"
                            )}
                            :
                          </span>
                        </Col>
                        <Col md={8}>
                          {jMoment(item.values.timeTo, "HH:mm:ss").format(
                            " HH:mm:ss"
                          )}
                        </Col>
                      </Row>
                    )}
                  </Row>
                )}
                <Col sm={4} className="request-info-title">
                  <MaterialIcon size="tiny" name="calendar" />{" "}
                  {app.translate("routes.home.requests.UpdatedAt2")}:
                </Col>
                <Col sm={8}>
                  <span dir="ltr">
                    {jMoment(item.updatedAt, "YYYY-M-D HH:mm:ss").format(
                      "jYYYY/jMM/jDD HH:mm:ss"
                    )}
                  </span>
                </Col>
                {item.values.description && (
                  <Col sm={24}>
                    <span className="request-info-title">
                      <MaterialIcon
                        size="tiny"
                        name="comment-processing-outline"
                      />{" "}
                      {app.translate("routes.home.requests.Description")}:
                    </span>
                    {item.values.description}
                  </Col>
                )}
              </Row>
              {index !== onClickRowsRequests.length - 1 ? (
                <div className="spacer" />
              ) : (
                ""
              )}
            </Col>
          ))}
        </Row>
      </Modal>
    );
  }
}
